module.exports = __webpack_public_path__ + "static/media/btn_bg.c60c969e.png";